<template>
  <div>
    <div class="wrapper d-flex flex-column align-center mx-2">
      <h1 class="mt-10">Εγγραφή</h1>

      <v-form id="myForm" @submit.prevent="submit" class="mb-2">
        <div class="d-flex flex-column fields">
          <v-text-field
            color="rgb(0,170,221)"
            label="Email*"
            v-model="email"
            prepend-inner-icon="mdi-email-outline"
            :error-messages="emailErrors"
            type="email"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Συνθηματικό*"
            v-model="password"
            prepend-inner-icon="mdi-lock-outline"
            type="password"
            :error-messages="passwordErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Επιβεβαίωση συνθηματικού*"
            v-model="confirmPassword"
            prepend-inner-icon="mdi-lock-outline"
            type="password"
            :error-messages="confirmPasswordErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Όνομα*"
            v-model="firstName"
            :error-messages="firstNameErrors"
          ></v-text-field>
          <v-text-field
            color="rgb(0,170,221)"
            label="Επώνυμο*"
            v-model="lastName"
            :error-messages="lastNameErrors"
          ></v-text-field>
          <v-autocomplete
            color="rgb(0,170,221)"
            label="Νομός κατοικίας*"
            :items="prefectures"
            item-value="option_key"
            item-text="option_value"
            v-model="prefecture"
            @change="getMunicipalities"
            :error-messages="prefectureErrors"
          ></v-autocomplete>

          <v-autocomplete
            color="rgb(0,170,221)"
            label="Δήμος κατοικίας*"
            v-model="municipalityCode"
            :items="municipalities"
            item-value="option_key"
            item-text="option_value"
            :loading="loadingLocal"
            :disabled="!prefecture"
            :error-messages="municipalityCodeErrors"
          ></v-autocomplete>

          <v-text-field
            prefix="(+30)"
            color="rgb(0,170,221)"
            label="Κινητό"
            v-model="mobile"
            :error-messages="mobileErrors"
          ></v-text-field>

          <v-autocomplete color="rgb(0,170,221)" label="Ηλικία" v-model="age" :items="ages"></v-autocomplete>

          <div class="mt-12 d-flex align-center">
            <v-checkbox
              height="10"
              v-model="terms"
              :error-messages="termsErrors"
              color="rgb(0,170,221)"
            >
              <template slot="label">
                <p class="mb-0 black--text" style="font-size:14px">
                  Συμφωνώ με τους
                  <span
                    @click.prevent="termsDialog=true"
                    class="font-weight-bold"
                    style="color:rgb(0,170,221);"
                  >Όρους και προϋποθέσεις</span>
                </p>
              </template>
            </v-checkbox>
          </div>

          <div class="d-flex align-center">
            <v-checkbox
              height="10"
              v-model="policy"
              :error-messages="policyErrors"
              color="rgb(0,170,221)"
            >
              <template slot="label">
                <p class="mb-0 black--text" style="font-size:14px">
                  Συμφωνώ με την
                  <span
                    @click.stop="privacyDialog=true"
                    class="font-weight-bold"
                    style="color:rgb(0,170,221); cursor:pointer"
                  >Πολιτική απορρήτου</span> της εταιρείας
                </p>
              </template>
            </v-checkbox>
          </div>

          <div class="align-self-center my-5">
              <vue-recaptcha
                sitekey="6LeqxOQUAAAAAHuqe3GbWMUANvKvtmc79l27dWKq"
                :loadRecaptchaScript="true"
                size="100"
                @verify="verify"
              ></vue-recaptcha>
          </div>
          <div class="d-flex justify-center my-5">
            <v-btn
              rounded
              depressed
              outlined
              height="40"
              width="100"
              color="rgb(0,170,221)"
              class="text-capitalize"
              @click="$router.go(-1)"
            >
              <p class="mb-0">Πίσω</p>
            </v-btn>

            <!-- <button>Click me</button> -->

            <v-btn
              type="submit"
              class="white--text text-capitalize ml-5"
              rounded
              depressed
              width="200"
              color="rgb(0,170,221)"
              height="40"
              :disabled="!enabled"
              :loading="$store.state.loading"
            >
              <p class="mb-0">Εγγραφή</p>
            </v-btn>
          </div>
        </div>
      </v-form>
    </div>

    <v-dialog id="dialogRelative" v-model="termsDialog">
      <v-card>
        <v-card-text>
          <v-icon
            style="position:sticky; left:1px; top:20px; cursor:pointer;"
            @click="termsDialog=false"
          >mdi-close</v-icon>
          <Terms class="pt-5 ml-8" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog id="dialogRelative" v-model="privacyDialog">
      <v-card>
        <v-card-text>
          <v-icon
            style="position:sticky;left:1px;top:10px; cursor:pointer;"
            @click="privacyDialog=false"
          >mdi-close</v-icon>
          <Privacy class="pt-10 ml-6" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Terms from "@/components/Terms.vue";
import Privacy from "@/components/Privacy.vue";
import { validationMixin } from "vuelidate";

import {
  required,
  sameAs,
  email,
  numeric,
  minLength,
  maxLength,
  requiredUnless
} from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
const signUpValidator = function() {
  return !this.signUpFailed;
};

export default {
  mixins: [validationMixin],
  components: {
    Terms,
    Privacy,
    VueRecaptcha
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/optionsList/greekPrefectures/el`)
      .then(res => {
        this.prefectures = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  data() {
    return {
      loadingLocal: false,
      signUpFailed: false,
      termsDialog: false,
      privacyDialog: false,

      municipalities: [],
      prefectures: [],

      //form
      email: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      prefecture: null,
      municipalityCode: null,
      mobile: "",
      age: null,
      policy: false,
      terms: false,

      enabled: false,

      //ages
      ages: [
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "67",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99"
      ]
    };
  },

  methods: {
    getMunicipalities() {
      this.loadingLocal = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefecture}`
        )
        .then(res => {
          this.loadingLocal = false;
          this.municipalities = res.data;
        })
        .catch(err => {
          this.loadingLocal = false;
          console.log(err);
        });
    },

    verify() {
      this.enabled = true;
    },

    submit() {
      // grecaptcha.execute();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        // this.$recaptcha("register").then(token => {

        const registerObj = {
          email: this.email,
          password: this.password,
          application: "app_traveller",
          preferredLanguage: {
            languageIsoCode: "el"
          }
        };

        const profileObj = {
          municipalityCode: this.municipalityCode,
          userProfile: {
            age: this.age,
            firstName: this.firstName,
            lastName: this.lastName,
            mobile: this.mobile
          }
        };

        this.$store
          .dispatch("userRegister", registerObj)
          .then(res => {
            console.log("userRegister", res);
            return this.$store.dispatch("userProfile", {
              obj: profileObj,
              token: this.$store.state.token
            });
          })
          .then(res => {
            console.log("serProfile", res);

            return this.$store.dispatch(
              "agreeWithTerms",
              this.$store.state.token
            );
          })
          .then(res => {
            this.$router.push("/register/verification");
            console.log(res);
          })
          .catch(err => {
            if (err.response.data.errorCode === 10401) {
              this.signUpFailed = true;
            }
          });
        // });
      } else {
        window.scrollTo(0, 0);
      }
    }
  },

  validations: {
    email: {
      required,
      email,
      signUpValidator
    },
    password: {
      required,
      minLength: minLength(4)
    },
    confirmPassword: {
      required,
      minLength: minLength(4),
      sameAsPassword: sameAs("password")
    },
    firstName: {
      required
    },
    lastName: {
      required
    },
    mobile: {
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric
    },
    prefecture: {
      required
    },
    municipalityCode: {
      required
    },
    terms: { checked: value => value === true },
    policy: { checked: value => value === true }
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Πρέπει να είναι σωστό email");
      if (!this.$v.email.signUpValidator)
        errors.push("Αυτό το email χρησιμοποιείται ήδη");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.password.minLength)
        errors.push("Πρέπει να είναι τουλάχιστον 4 χαρακτήρες");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      if (!this.$v.confirmPassword.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.confirmPassword.minLength)
        errors.push("Πρέπει να είναι τουλάχιστον 4 χαρακτήρες");
      if (!this.$v.confirmPassword.sameAsPassword)
        errors.push("Πρέπει να είναι ίδιο με το συνθηματικό");
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      if (!this.$v.firstName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      if (!this.$v.mobile.numeric) errors.push("Πρέπει να είναι αριθμός");
      if (!this.$v.mobile.minLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.maxLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      return errors;
    },

    prefectureErrors() {
      const errors = [];
      if (!this.$v.prefecture.$dirty) return errors;
      if (!this.$v.prefecture.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    municipalityCodeErrors() {
      const errors = [];
      if (!this.$v.municipalityCode.$dirty) return errors;
      if (!this.$v.municipalityCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    termsErrors() {
      const errors = [];
      if (!this.$v.terms.$dirty) return errors;
      if (!this.$v.terms.checked) errors.push("");
      return errors;
    },
    policyErrors() {
      const errors = [];
      if (!this.$v.policy.$dirty) return errors;
      if (!this.$v.policy.checked) errors.push("");
      return errors;
    }
  },

  watch: {
    email(newValue, oldValue) {
      if ((oldValue !== "" && newValue === "") || newValue !== oldValue) {
        this.signUpFailed = false;
      }
    }
  }
};
</script>